var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { getObservableT } from "../Infra/i18next";
import { ErrorEvent, EventCategory } from "healthex-common/analytics.dtos";
const t = getObservableT("common");
export class RouteErrorViewModel {
    constructor(container) {
        this.appUIManager = container.appUIManager;
        this.browserLanguageUIManager = container.browserLanguageUIManager;
        this.analyticsService = container.analyticsService;
        this.authManager = container.authManager;
    }
    get translationsNotAvailable() {
        return this.browserLanguageUIManager.translationsNotAvailable;
    }
    get title() {
        return this.translationsNotAvailable ? "Something went wrong" : t("Something went wrong");
    }
    get message() {
        return this.translationsNotAvailable
            ? "Please contact support if this problem persists."
            : t("Please contact support if this problem persists.");
    }
    get reloadButtonText() {
        return this.translationsNotAvailable ? "Reload" : t("Reload");
    }
    get goHomeButtonText() {
        return this.translationsNotAvailable ? "Back to Home" : t("Back to Home");
    }
    get showStackTrace() {
        return this.appUIManager.isDebugMode;
    }
    goHome() {
        this.appUIManager.navigateToHome();
    }
    trackError(errorMessage, errorStackTrace) {
        var _a;
        if (!errorStackTrace)
            return;
        const metadata = {
            userType: (_a = this.authManager.userType) !== null && _a !== void 0 ? _a : undefined,
            errorMessage,
            errorStackTrace,
        };
        void this.analyticsService.trackPublicEvent({
            category: EventCategory.ERROR,
            action: ErrorEvent.UI_STACK_TRACE,
            metadata,
        });
    }
}
__decorate([
    computed
], RouteErrorViewModel.prototype, "translationsNotAvailable", null);
__decorate([
    computed
], RouteErrorViewModel.prototype, "title", null);
__decorate([
    computed
], RouteErrorViewModel.prototype, "message", null);
__decorate([
    computed
], RouteErrorViewModel.prototype, "reloadButtonText", null);
__decorate([
    computed
], RouteErrorViewModel.prototype, "goHomeButtonText", null);
__decorate([
    computed
], RouteErrorViewModel.prototype, "showStackTrace", null);
